import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Box, Button, useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import moment from 'moment'

import CardPreview from 'packages/ui/CardPreview'
import { SideContent } from 'components-shared'
import { downloadBase64 } from 'utils'

import DeleteInMass from '../Actions/DeleteInMass'
import ResetInMass from '../Actions/ResetInMass'
import { useItemsSelected } from '../store'
import { OPERATION_EXPORT_RAN_ROOM } from '../operations-gql/queries'
import { trackEvent } from 'analytics'

const Export = () => {
  const { t } = useTranslation();
  const {siteId} = useParams()
  const { i18n } = useTranslation()
  const [itemsSelected] = useItemsSelected()
  const [launchExport, { loading }] = useLazyQuery(OPERATION_EXPORT_RAN_ROOM)
  const handleExport = async () => {
    trackEvent('private_wifi_export', {
      action_scope: 'bulk',
      item_count: itemsSelected.length,
      format: 'pdf',
    })
    const {
      data: { base64 },
    } = await launchExport({
      variables: { sf_id: siteId, room_ids: itemsSelected.map(({id}) => id), format: 'pdf', language: i18n.language },
    })
    await downloadBase64({ base64, fileName: `rans_${moment().format('YYYY/MM/DD')}.pdf`})
  }
  return (
    <Button
      disabled={loading}
      startIcon={<i className={'fa-regular fa-file-arrow-up'} style={{fontSize: 14}}/>}
      size={'small'}
      variant={'outlined'}
      onClick={() => handleExport()}
    >
      {loading ? t('ui_elements.in_progress') : t('ui_elements.export')}
    </Button>
  )
}
const CardInMass = () => {
  const { t } = useTranslation()
  const [itemsSelected, setItemsSelected] = useItemsSelected()
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openResetModal, setOpenResetModal] = useState(false)
  const theme = useTheme()
  return (
    <SideContent style={{ maxWidth: '440px', marginTop: 0 }}>
      {
        openDeleteModal && <DeleteInMass onClose={() => setOpenDeleteModal(false)}></DeleteInMass>
      }
      {
        openResetModal && <ResetInMass onClose={() => setOpenResetModal(false)}></ResetInMass>
      }
      <CardPreview title={t('ran.card_selection.title', {count: itemsSelected.length})} onClose={() => setItemsSelected([])}>
        <Stack gap={1} sx={{ height: '100%', minHeight: 0, overflow: 'hidden' }}>
          <Stack gap={1} sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
              {
                itemsSelected.map((item) => (
                  <Stack
                    key={item.id}
                    direction={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    mr={.75}
                  >
                    <Box sx={{fontSize: 12}}>{item.name}</Box>
                    <Box
                      ml={1}
                      mr={1}
                      sx={{
                        display: 'flex',
                        flexGrow: 1,
                        height: '1px',
                        backgroundColor: theme.palette.grey[100]
                    }} />
                    <Stack sx={{
                      width: 20,
                      height: 20,
                      backgroundColor: theme.palette.grey[100],
                      borderRadius: 2,
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                      <i
                        className={'fa-solid fa-minus'}
                        style={{cursor: 'pointer', color: theme.palette.grey[400], fontSize: 12}}
                        onClick={() => {
                          setItemsSelected(prev => prev.filter(({id}) => id !== item.id))
                        }}
                      />
                    </Stack>
                  </Stack>
                ))
              }
          </Stack>
          <Stack
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            sx={{
              flexShrink: 0,
              marginTop: 'auto',
              paddingTop: 1,
              backgroundColor: theme.palette.common.white
            }}
          >
              <Box
                pt={1}
                pb={1}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 35,
                  height: 35,
                  borderRadius: 1,
                  border: '1px solid #F9DCDC',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  trackEvent('private_wifi_delete', {
                    action_scope: 'bulk',
                    item_count: itemsSelected.length,
                  })
                  setOpenDeleteModal(true)
                }}
              >
                <i className={'fa-regular fa-trash'} style={{color: theme.palette.error.main}} />
              </Box>
              <Stack direction={'row'} gap={1}>
                <Export />
                <Button
                  size={'small'}
                  variant={'outlined'}
                  onClick={() => {
                    trackEvent('private_wifi_reset', {
                      action_scope: 'bulk',
                      item_count: itemsSelected.length,
                    })
                    setOpenResetModal(true)
                  }}
                >
                  {t('ui_elements.reset')}
                </Button>
              </Stack>
          </Stack>
        </Stack>
      </CardPreview>
    </SideContent>
  )
}

export default CardInMass
